import React from "react";
import { SimpleGrid, VStack, Image } from "@chakra-ui/react";
import {
  ImLibrary,
  ImUsers,
  IoIosSend,
  MdAccessTime,
  RiCalendarCheckFill,
} from "react-icons/all";

import { DateObjectType } from "utils/DateObject";

import { ChakraText } from "components/ChakraText";
import { DetailFrame } from "components/DetailFrame";

import { GroupName } from "./GroupName";
import { QueueName } from "./QueueName";

import booking from "assets/booking.svg";

interface IReservationDetails {
  startDate: DateObjectType;
  endDate: DateObjectType;
  groupId?: string;
  queueId?: string;
  email?: string;
}

interface IProps<T> {
  appointment: T;
}

const ReservationDetails = <T extends IReservationDetails>({
  appointment,
}: IProps<T>) => {
  return (
    <SimpleGrid
      mx="auto"
      w={{
        sm: "100%",
        md: "80%",
      }}
      columns={{ sm: 1, md: 2 }}
      mt={8}
      spacing={6}
      justifyContent="center"
      justifyItems="center"
      textAlign="center"
    >
      <VStack spacing={6}>
        {appointment.groupId && (
          <DetailFrame icon={ImLibrary} tooltipLabel="Grupa">
            <GroupName groupId={appointment.groupId} />
          </DetailFrame>
        )}

        {appointment.queueId && (
          <DetailFrame icon={ImUsers} tooltipLabel="Kolejka">
            <QueueName queueId={appointment.queueId} />
          </DetailFrame>
        )}
        <DetailFrame icon={RiCalendarCheckFill} tooltipLabel="Termin wizyty">
          <ChakraText>{appointment.startDate.userFormat()}</ChakraText>
        </DetailFrame>
        <DetailFrame icon={MdAccessTime} tooltipLabel="Czas wizyty">
          <ChakraText>
            {appointment.startDate.getTime()} -{" "}
            {appointment.endDate.getTime()}
          </ChakraText>
        </DetailFrame>
        {appointment.email && (
          <DetailFrame icon={IoIosSend} tooltipLabel="Email">
            <ChakraText>{appointment.email}</ChakraText>
          </DetailFrame>
        )}
      </VStack>
      <Image
        maxH="400px"
        src={booking}
        display={{
          base: "none",
          md: "block",
        }}
        alt="Podsumowanie rezerwacji - zdjęcie kalendarza"
      />
    </SimpleGrid>
  );
};

export { ReservationDetails };
